import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { AUTH_SESSION_EXPIRED_EVENT } from '../authSession';

const SESSION_EXPIRED_TOAST_ID = 'session-expired';

const SessionExpiredListener: React.FC = () => {
  useEffect(() => {
    const onSessionExpired = () => {
      toast.error(
        'Your session has expired. Please sign in again to continue.',
        {
          id: SESSION_EXPIRED_TOAST_ID,
          duration: 8000,
        }
      );
    };

    window.addEventListener(AUTH_SESSION_EXPIRED_EVENT, onSessionExpired);
    return () => window.removeEventListener(AUTH_SESSION_EXPIRED_EVENT, onSessionExpired);
  }, []);

  return null;
};

export default SessionExpiredListener;
